import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { loginAccion } from "../redux/informacion_principal";
/* import InputsPassword from "./InputsPassword"; */
import { useTranslation } from "react-i18next";
import "../styles/login.css";
import Cookies from "universal-cookie";
import { showAlertAccion, closeAlertAccion } from "../redux/alert_webtrade";

function Login() {
  /*const socket = new WebSocket('ws://localhost:8080');
    
    socket.onopen = () => {
        console.log('Conexión establecida en cliente');
        socket.send('Hola servidor desde el cliente');
    };
    socket.onmessage = (event) => {
        //console.log('Mensaje recibido:', event.data);
        console.log('Mensaje recibido: en cliente1');
    };
    socket.onmessage = (mensaje) => {
        //console.log('Mensaje recibido:', event.data);
        console.log('onmessage1: en cliente: ',mensaje.data);
        //socket.send('envio mensaje');
    };
    socket.onclose = () => {
        console.log('Conexión cerrada en cliente');
    };*/

  const cookies = new Cookies();

  useEffect(() => {
    // let token = cookies.get('userTokenS', { path: '/'});
    // if (!token){
    //     cookies.set("userTokenS", '', {path: "/"});
    // }
  }, []);

  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [type, setType] = useState("password");
  const { t } = useTranslation();

  const dispatch = useDispatch();

    const openAlert = (message,typeAlert) =>{
        dispatch(showAlertAccion({message,typeAlert}));
    }

    const closeAlert = () =>{
    dispatch(closeAlertAccion());
    }

  const logIn = async () => {
    try {
            openAlert(t('login.login'), 'light');
      // Realiza el inicio de sesión
            const returns = await dispatch(loginAccion({usuario,password})) 
            console.log('returns',returns)
            await new Promise(resolve => setTimeout(resolve, 5000));
      // Verifica el resultado del inicio de sesión
            console.log('validamos')
            if (returns === 'error') {
                console.error('Error al iniciar sesión:', returns);
        activarAlerta();
      }
      // Cierra la alerta
    } catch (error) {
            console.error('Error general:', error);
      // Manejar el error de manera adecuada
    }
    closeAlert();
  };

  const changeType = () => {
    if (type === "password") {
      setType("text");
    } else {
      setType("password");
    }
  };

  const activarAlerta = () => {
    console.log("ACTIVAR ERROR");
    const alertdiv = document.getElementById("div-alert");
    alertdiv.classList.remove("d-none");
    alertdiv.classList.add("show");

    const alert = document.querySelector("#alert");
    alert.classList.add("show");

    setTimeout(() => {
      alert.classList.remove("show");
      alertdiv.classList.add("d-none");
    }, 5000);
  };

  return (
    <React.Fragment>
      <section className="d-flex justify-content-center align-items-center">
        <div className="container">
          <div className="row">
            <div className="col-sm-8 col-md-8 col-lg-8 offset-sm-2 offset-md-2 offset-lg-2">
              <div className="card pt-4 animate-box" id="login-card">
                <div className="card-body">
                  <div className="card-title d-flex justify-content-center">
                    <img
                      src="/img/logo-tipo2.png"
                      style={{ maxWidth: "230px" }}
                    />
                  </div>
                  <div className="card-text">
                    <div className="container py-5 px-1">
                      <div className="row row-gap-4">
                        <div className="col-sm-12 col-md-8 col-lg-8 offset-md-2 offset-lg-2">
                          <div className="input-group mb-3">
                            <span
                              className="input-group-text"
                              id="basic-addon1"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                fill="currentColor"
                                className="bi bi-envelope-at"
                                viewBox="0 0 16 16"
                              >
                                <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2zm3.708 6.208L1 11.105V5.383zM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2z" />
                                <path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648m-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z" />
                              </svg>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder={t("login.user")}
                              aria-label="Cuenta"
                              aria-describedby="basic-addon1"
                              style={{ fontSize: "1.2rem" }}
                              onChange={(e) =>
                                setUsuario(e.target.value.trim())
                              }
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-8 col-lg-8 offset-md-2 offset-lg-2">
                          <div className="input-group mb-3">
                            <span
                              className="input-group-text"
                              id="basic-addon1"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                fill="currentColor"
                                className="bi bi-key"
                                viewBox="0 0 16 16"
                              >
                                <path d="M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8m4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.793-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5" />
                                <path d="M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                              </svg>
                            </span>
                            <input
                              type={type}
                              className="form-control"
                              placeholder={t("login.password")}
                              aria-label="Contraseña"
                              aria-describedby="basic-addon1"
                              style={{ fontSize: "1.2rem" }}
                              onChange={(e) =>
                                setPassword(e.target.value.trim())
                              }
                            />
                            <div className="input-group-append">
                              <button
                                className="btn btn-outline-secondary ps-3"
                                type="button"
                                style={{
                                  fontSize: "1.3rem",
                                  border: "#babbbc solid 0.5px",
                                  backgroundColor: "bg-secondary",
                                }}
                                onClick={() => changeType()}
                              >
                                {type === "password" ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    fill="bg-secondary"
                                    className="bi bi-eye pb-1"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                  </svg>
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    fill="bg-secondary"
                                    className="bi bi-eye-slash pb-1"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                                    <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                                    <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                                  </svg>
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-12 d-flex justify-content-center">
                          <button
                            type="button"
                            className="btn"
                            id="btn-login"
                            onClick={() => logIn()}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="22"
                              fill="currentColor"
                              className="bi bi-box-arrow-in-right mb-1 me-2"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fillRule="evenodd"
                                d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"
                              />
                              <path
                                fillRule="evenodd"
                                d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
                              />
                            </svg>
                            {t("login.enter")}
                          </button>
                        </div>
                        <div
                          className="col-sm-12 col-md-8 col-lg-8 offset-md-2 offset-lg-2 d-none"
                          id="div-alert"
                        >
                          <div
                            id="alert"
                            className="alert alert-danger fade"
                            role="alert"
                          >
                            <strong>{t("login.error")}</strong>{" "}
                            {t("login.error_message")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default Login;
